// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2068":"f3c91cb26c7bdddc","2442":"96f5621d215a32d3","3364":"e4f48de1bc688f69","8010":"5efa1690f337da2c","8467":"a6e78d27df206688"}[chunkId] + ".css";
};